// extracted by mini-css-extract-plugin
export default {"asset":"ProfileCampaignCard_asset__FDDCj","info":"ProfileCampaignCard_info__aPtQa","text":"ProfileCampaignCard_text__JHh8D"};